const size = require('lodash/size');
const Lang = require('lang');
const ga4 = require('../ga4/ga4');

// Adiciona um interceptor na seleção da option do select e chama o evento do ga4 se necessário
window.Selectize.define('ga4_interceptor', function(options) {
  const self = this;
  const setup = self.setup;

  this.setup = function() {
    setup.apply(self, arguments);

    self.$dropdown.off('mousedown click', '[data-selectable]').on('mousedown click', '[data-selectable]', function(e) {
      const value = $(this).attr('data-value'), inputValue = self.$input.attr('value') || '';

      if (inputValue.indexOf(value) !== -1) {
        const inputValueArray = inputValue.split(','), index = inputValueArray.indexOf(value);
        console.log((self.$input.data('ga4-id')));

        inputValueArray.splice(index, 1);

        self.setValue(inputValueArray);
        self.focus();
      } else {
        self.onOptionSelect.apply(self, arguments);
      }

      // Caso o elemento possua o id do ga4 dispara o evento correspondente
      if (!!self.$input.data('ga4-id')) {
        ga4.event(self.$input.data('ga4-id'))(self.$input);
      }
    });
  }
});

function makeSelectize(id, phrase, canAdd, max) {
  const select = $(id);
  const selected = select.data('selected');

  if (!select.length) {
    return false;
  }

  phrase = Lang.get('js/src/functions/makeSelectize.no_data_to_select') || phrase;
  canAdd = canAdd === 'true' ? true : false;
  max = false || max;

  const selectize = select.selectize({
    plugins: ['restore_on_backspace', 'remove_button', 'ga4_interceptor'],
    create: !canAdd ? canAdd : function (input){
      const obj = $(this.$input)[0].selectize.options
      const requestArray = [];

      for (const key in obj) {
        const text = obj[key].text;

        if(text.toLowerCase().includes(input.toLowerCase())) {
          requestArray.push(parseInt(obj[key].value))
        }
      }

      return { value:requestArray, text:input};
    },
    maxItems: max,
    selectOnTab: true,
    hideSelected: true,
    render: {
      option_create: function(data) {
        const label = Lang.get('js/src/functions/makeSelectize.add_filter');
        const content = escape(data.input);
        return `<div class='create'>&nbsp;${label}:&nbsp;<strong>${content}</strong>...<div>`;
      }
    },
    onChange: function() {
      const event = new Event('change', {bubbles: true});
      this.$input[0].dispatchEvent(event);
      try {
        this.$input.valid();
      } catch (e) {}
    },
    onDelete: function(data) {
      if (data[0].includes(',')) {
        this.$input[0].selectize.removeOption(data)
      }
    },
    onBlur: function () {
      const event = new Event('blur', {bubbles: true});
      this.$input[0].dispatchEvent(event);
    }
  });

  const $selectize = selectize[0].selectize;

  if (size($selectize.options) < 1) {
    $selectize.settings.placeholder = phrase;
    $selectize.updatePlaceholder();
  }

  if (selected) {
    $selectize.setValue(selected, true);
  }

  return $selectize;
};

module.exports = makeSelectize;

